// extracted by mini-css-extract-plugin
export default {"cardWrapper":"RekomendasiKarir_cardWrapper__q7AxA","card":"RekomendasiKarir_card__LSurw","btn":"RekomendasiKarir_btn__FVOQZ","cardGrid":"RekomendasiKarir_cardGrid__u0+GT"};